import React, { useEffect, useRef, useState } from 'react';
import { Button, TextField, Checkbox, FormControlLabel, CircularProgress } from '@material-ui/core';

import { confirmarCodigo, reenviarCodigo } from './api';
import { Form } from './styles';

// Segundo passo do login: o código de 6 dígitos que chegou por e-mail.
// Recebe a resposta do login com dois_fatores (desafio, email, reenviar_em).
export var VerificacaoCodigo = function(props) {
    var desafioInicial = props.desafio;
    var onConfirmado = props.onConfirmado;
    var onVoltar = props.onVoltar;

    var desafioState = useState(desafioInicial);
    var desafio = desafioState[0];
    var setDesafio = desafioState[1];
    var codigoState = useState('');
    var codigo = codigoState[0];
    var setCodigo = codigoState[1];
    var lembrarState = useState(true);
    var lembrar = lembrarState[0];
    var setLembrar = lembrarState[1];
    var enviandoState = useState(false);
    var enviando = enviandoState[0];
    var setEnviando = enviandoState[1];
    var erroState = useState('');
    var erro = erroState[0];
    var setErro = erroState[1];
    var avisoState = useState('');
    var aviso = avisoState[0];
    var setAviso = avisoState[1];
    var esperaState = useState(desafioInicial.reenviar_em || 60);
    var espera = esperaState[0];
    var setEspera = esperaState[1];
    var campo = useRef(null);

    useEffect(function() {
        if (espera <= 0) return undefined;
        var timer = setTimeout(function() { setEspera(espera - 1); }, 1000);
        return function() { clearTimeout(timer); };
    }, [espera]);

    var confirmar = function(valor) {
        if (enviando || valor.length !== 6) return;
        setEnviando(true);
        setErro('');
        confirmarCodigo(desafio.desafio, valor, lembrar)
            .then(function(data) {
                onConfirmado(data);
            })
            .catch(function(error) {
                var resposta = error.response && error.response.data ? error.response.data : {};
                if (resposta.refazer_login) {
                    onVoltar(resposta.message || 'O código expirou. Entre de novo com a sua senha.');
                    return;
                }
                setErro(resposta.message || 'Não foi possível confirmar o código. Tente de novo.');
                setCodigo('');
                setEnviando(false);
                if (campo.current) campo.current.focus();
            });
    };

    var alterarCodigo = function(e) {
        var valor = (e.target.value || '').replace(/\D/g, '').slice(0, 6);
        setCodigo(valor);
        if (erro) setErro('');
        if (valor.length === 6) confirmar(valor);
    };

    var reenviar = function() {
        if (espera > 0 || enviando) return;
        setErro('');
        setAviso('');
        reenviarCodigo(desafio.desafio)
            .then(function(data) {
                setDesafio(data);
                setEspera(data.reenviar_em || 60);
                setCodigo('');
                setAviso('Enviamos um código novo.');
            })
            .catch(function(error) {
                var resposta = error.response && error.response.data ? error.response.data : {};
                if (resposta.refazer_login) {
                    onVoltar(resposta.message || 'Entre de novo com a sua senha.');
                    return;
                }
                setErro(resposta.message || 'Não foi possível reenviar agora.');
            });
    };

    return (
        <Form onSubmit={function(e) { e.preventDefault(); confirmar(codigo); }}>
            <div style={{ textAlign: 'center', marginBottom: 18 }}>
                <div style={{ fontSize: 17, fontWeight: 600, color: '#262626', marginBottom: 6 }}>
                    Confirme que é você
                </div>
                <div style={{ fontSize: 13, color: '#595959', lineHeight: '19px' }}>
                    Enviamos um código de 6 dígitos para <strong>{desafio.email}</strong>.
                </div>
            </div>
            <TextField
                inputRef={campo}
                label="Código de acesso"
                value={codigo}
                onChange={alterarCodigo}
                autoFocus
                fullWidth
                disabled={enviando}
                error={!!erro}
                helperText={erro || aviso || ' '}
                inputProps={{
                    inputMode: 'numeric',
                    autoComplete: 'one-time-code',
                    maxLength: 6,
                    style: { fontSize: 26, letterSpacing: 10, textAlign: 'center' },
                }}
            />
            <FormControlLabel
                style={{ marginTop: 4, marginBottom: 8 }}
                control={
                    <Checkbox
                        checked={lembrar}
                        onChange={function(e) { setLembrar(e.target.checked); }}
                        color="primary"
                        size="small"
                    />
                }
                label={<span style={{ fontSize: 13, color: '#595959' }}>Lembrar deste computador por 30 dias</span>}
            />
            <Button type="submit" variant="contained" color="primary" fullWidth disabled={enviando || codigo.length !== 6}>
                {enviando ? <CircularProgress size={22} style={{ color: '#fff' }} /> : 'CONFIRMAR'}
            </Button>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 16, fontSize: 13 }}>
                <a onClick={function() { onVoltar(''); }} style={{ color: '#8c8c8c', cursor: 'pointer' }}>
                    Voltar
                </a>
                {espera > 0 ? (
                    <span style={{ color: '#bfbfbf' }}>Reenviar código em {espera}s</span>
                ) : (
                    <a onClick={reenviar} style={{ color: '#722ed1', cursor: 'pointer' }}>Reenviar código</a>
                )}
            </div>
            <div style={{ marginTop: 14, fontSize: 12, color: '#a0a0a0', textAlign: 'center', lineHeight: '17px' }}>
                Não chegou? Confira o spam. O código vale por 10 minutos.
            </div>
        </Form>
    );
};
